import React from 'react'
import {configurationForm} from '../helpers/fieldGroups';
import { deprecatedClients } from '../clients/deprecated';
import { checkAccessLevel } from '../helpers/access';

class BaseConfig extends React.Component {

  constructor(){
    super();
    return "user_id" in sessionStorage ? this.getConfig() : this.getBaseConfig();
  }

  getConfig(){
    return JSON.parse(sessionStorage.getItem('config') || this.setConfig());
  }

  setConfig(){
    const config = JSON.stringify(this.generateConfig());
    sessionStorage.setItem('config', config);
    return config;
  }

  getBaseConfig(){
    return {
      domains: {
        'default': {
          logo: 'msh'
        },
        'www.mshagents.com': {
          logo: 'msh'
        },
        'dashboard.rimiinsurance.com': {
          logo: 'rimi'
        },
        'dev-dashboard.rimiinsurance.com': {
          logo: 'rimi'
        },
        'dashboard.msh-insurance.com': {
          logo: 'msh'
        },
        'dev-dashboard.msh-insurance.com': {
          logo: 'msh'
        },
        'dashboard.studyinsured.com': {
          logo: 'studyinsured'
        },
        'dashboard.msg-insurance.com': {
          logo: 'msg'
        },
        'dev-dashboard.msg-insurance.com': {
          logo: 'msg'
        },
        'dashboard.2visitcanada-insurance.com': {
          logo: '2visitcanada'
        },
        'dev-dashboard.2visitcanada-insurance.com': {
          logo: '2visitcanada'
        },
        'insurecanada.policy-dashboard.com': {
          logo: 'insurecanada'
        },
        'dev-insurecanada.policy-dashboard.com': {
          logo: 'insurecanada'
        }
      },
      scopes: {
        readonly: [
          'ingle.insurance.admin_readonly'
        ],
        superadmin: [
          'ingle.insurance.superadmin'
        ],
        admin: [
          'ingle.insurance.admin'
        ],
        schooladmin: [
          'ingle.insurance.schooladmin'
        ],
        groupadmin: [
          'ingle.insurance.schooladmin'
        ],
        schoolsuperadmin: [
          'ingle.insurance.schoolsuperadmin'
        ],
        agent: [
          'ingle.insurance.agent'
        ],
        mga: [
          'ingle.insurance.mga'
        ],
        masteradmin: [
          'novus.admin'
        ],
        mshadmin: [
          'mshadmin'
        ],
        viewonly: [
          'viewonly'
        ]
      },
      locale:{
        'en': 'en-US',
        'fr': 'fr-CA',
      }
    }
  }

  generateConfig(){
    return {
      ...this.getBaseConfig(),
      currency_format: {
        symbol: 'CAD',
        format: '$%v %s'
      },
      currency_format_usd: {
        symbol: 'USD',
        format: '$%v %s'
      },
      payment_provider: 'stripe',
      landing: {
        ingle: {
          tiles: {
            'masteradmin': ['products', 'search_quotes', 'search_policies',  'search_reports', 'reporting', 'commissions', 'users', 'create_user', 'dropbox', 'bulkuploadlist', 'documents'],
            'superadmin': ['products', 'search_quotes', 'search_policies', 'search_reports', 'reporting', 'commissions', 'dropbox', 'bulkuploadlist', 'documents'],
            'admin': ['products', 'search_quotes', 'search_policies', 'search_reports', 'commissions', 'dropbox', 'bulkuploadlist', 'documents'],
            'groupadmin': ['products', 'search_quotes', 'search_policies', 'search_reports', 'reporting', 'commissions', 'documents'],
            'schooladmin': ['products', 'search_policies', 'search_reports', 'reporting', 'dropbox', 'documents'],
            'schoolsuperadmin': ['products', 'search_policies', 'search_reports', 'reporting', 'dropbox', 'documents'],
            'viewonly': ['search_policies', 'documents'],
            'agent': ['commissions', 'product_categories', 'search_quotes', 'search_policies', 'resource_centre', 'contact_us', 'documents'],
            'readonly': ['products', 'search_quotes', 'search_policies', 'documents'],
          },
          titles: {
            'masteradmin': 'MSH',
            'superadmin': 'MSH',
            'admin': 'MSH',
            'groupadmin': 'Admin',
            'schooladmin': 'Admin',
            'schoolsuperadmin': 'Admin',
            'viewonly': 'Admin',
            'agent': 'MSH',
            'readonly': 'MSH',
          }
        },
        rimi: {
          title: 'RIMI',
          tiles: {
            'admin': ['products', 'search_quotes', 'search_policies', 'reporting', 'users', 'create_user', 'documents'],
            'mga': ['products', 'search_quotes', 'search_policies', 'documents'],
            'agent': ['products', 'search_quotes', 'search_policies', 'documents'],
            'readonly': ['products', 'search_quotes', 'search_policies', 'documents'],
          },
        },
        msg: {
          title: 'MSG',
          tiles: {
            'superadmin': ['product_categories', 'search_quotes', 'search_policies', 'commissions', 'users', 'create_user'],
            'admin': ['product_categories', 'search_quotes', 'search_policies', 'commissions', 'users', 'create_user'],
            'agent': ['product_categories', 'search_quotes', 'search_policies'],
            'readonly': ['search_policies'],
          },
        },
        visitcanada: {
          title: '2 VISIT CANADA',
          tiles: {
            'admin': ['products', 'search_quotes', 'search_policies', 'reporting', 'users', 'create_user', 'documents'],
            'mga': ['products', 'search_quotes', 'search_policies', 'documents'],
            'agent': ['products', 'search_quotes', 'search_policies', 'documents'],
            'readonly': ['products', 'search_quotes', 'search_policies', 'documents'],
          },
        },
          insurecanada: {
          title: 'INSURE CANADA',
          tiles: {
            'admin': ['products', 'search_quotes', 'search_policies', 'reporting', 'users', 'create_user', 'documents'],
            'mga': ['products', 'search_quotes', 'search_policies', 'documents'],
            'agent': ['products', 'search_quotes', 'search_policies', 'documents'],
            'readonly': ['products', 'search_quotes', 'search_policies', 'documents'],
          },
        },
        tiles: {
          products: {
            label: 'Products',
            icon: 'shopping-cart',
            link: 'products',
          },
          product_categories: {
            label: 'Sell Now',
            icon: 'list',
            link: 'products',
          },
          agent_products: {
            label: 'All Products',
            icon: 'shopping-cart',
            link: 'agent_products',
            custom_link: 'https://agents.msh-insurance.com/login/en/travel-insurance/agent-products/agentcode',
          },
          users: {
            label: 'Users',
            icon: 'users',
            link: 'user_management',
          },
          create_user: {
            label: 'Create User',
            icon: 'user',
            link: 'create_user',
          },
          search_policies: {
            label: 'Policies',
            icon: 'search',
            link: 'search/universal',
          },
          search_quotes: {
            label: 'Quotes',
            icon: 'search',
            link: 'quotes/universal',
          },
          search_claims: {
            label: 'Claims',
            icon: 'search',
            link: 'claim_management',
          },
          bulk_upload: {
            label: 'Bulk Upload',
            icon: 'search',
            link: 'upload',
          },
          commissions: {
            label: 'Commissions',
            icon: 'money',
            link: 'commissions',
          },
          dropbox: {
            label: 'File Exchange',
            icon: 'dropbox',
            link: 'file_exchange',
          },
          reporting: {
            label: 'Reporting',
            icon: 'file-excel-o',
            link: 'reporting',
          },
          resource_centre: {
            label: 'Resource Centre',
            icon: 'info-circle',
            link: 'resource_centre',
          },
          contact_us: {
            label: 'Contact Us',
            icon: 'phone',
            link: 'contact_us',
          },
          documents: {
            label: 'Documents',
            icon: 'files-o',
            link: 'documents',
          },
          bulkuploadlist: {
            label: 'Bulk Upload History',
            icon: 'upload',
            link: 'bulkuploadlist',
          },
          search_reports: {
            label: 'Reports History',
            icon: 'download',
            link: 'reports/universal',
          },
        }
      },
      search_params: {
        applicant: {
          url_base: 'api',
          url_suffix: '/search/applicant/',
          search_title: 'Policies'
        },
        quote: {
          url_base: 'api',
          url_suffix: '/search/quotes/',
          search_title: 'Quotes'
        },
        report: {
          url_base: 'api',
          url_suffix: '/search/reports/',
          search_title: 'Reports'
        },
        user: {
          url_base: 'auth_base_api',
          url_suffix: '/member/',
          search_title: 'Users'
        },
        claim: {
          url_base: 'api',
          url_suffix: '/search/claim/',
          search_title: 'Claims'
        }
      },
      search: {
        applicant: {
          ingle: [
            {
              key: 'first_name',
              as: 'First Name'
            },
            {
              key: 'last_name',
              as: 'Last Name'
            },
            {
              key: 'date_of_birth',
              as: 'Date of Birth',
              format: 'date'
            },
            {
              key: 'policy_number',
              as: 'Policy Number',
              show_for: 'applicant'
            },
            {
              key: 'phone_number',
              as: 'Phone Number'
            },
            {
              key: 'email',
              as: 'Email'
            },
            {
              key: 'sale_date_from',
              as: 'Sale Date From',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'sale_date_to',
              as: 'Sale Date To',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'effective_date_from',
              as: 'Effective Date From',
              format: 'date'
            },
            {
              key: 'effective_date_to',
              as: 'Effective Date To',
              format: 'date'
            },
            {
              key: 'last_updated_from',
              as: 'Last Updated From',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'last_updated_to',
              as: 'Last Updated To',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'tracking_code',
              as: 'Referrer',

            },
            {
              key: 'student_id',
              as: 'Student ID'
            },
            {
              key: 'status',
              as: 'Status',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: 'active',
              options: [
                {
                  value: 'all',
                  text: 'All'
                },
                {
                  value: 'active',
                  text: 'Active'
                },
                {
                  value: 'sold',
                  text: 'Sold'
                },
                {
                  value: 'expired',
                  text: 'Expired'
                },
                {
                  value: 'cancelled',
                  text: 'Cancelled'
                },
                {
                  value: 'pending payment',
                  text: 'Incomplete Application'
                },
                {
                  value: 'void',
                  text: 'Void'
                },
              ]
            },
            {
              key: 'application_id',
              as: 'Application ID'
            },
            {
              key: 'insurer',
              as: 'Underwriter',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: 'all',
              options: [
                {value: 'all', text:'All'},
                {value: 'lloyds', text:'Lloyd\'s'},
                {value: 'berkley', text:'Berkley'}
              ]
            },
            {
              key: 'school_name',
              as: 'School'
            },
            {
             key: 'org',
             as: '',
             type: 'hidden',
             value: 'ingle'
            },
            {
              key: 'sources',
              as: 'Product',
              type: 'multiselect',
              options: [],
              col_width: 12,
            }
          ],
          rimi: [
            {
              key: 'first_name',
              as: 'First Name'
            },
            {
              key: 'last_name',
              as: 'Last Name'
            },
            {
              key: 'date_of_birth',
              as: 'Date of Birth',
              format: 'date'
            },
            {
              key: 'policy_number',
              as: 'Policy Number',
              show_for: 'applicant'
            },
            {
              key: 'phone_number',
              as: 'Phone Number'
            },
            {
              key: 'email',
              as: 'Email'
            },
              {
              key: 'sale_date_from',
              as: 'Sale Date From',
              format: 'date',
              max_date: 'today'
            },
             {
              key: 'sale_date_to',
              as: 'Sale Date To',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'effective_date_from',
              as: 'Effective Date From',
              format: 'date'
            },
            {
              key: 'effective_date_to',
              as: 'Effective Date To',
              format: 'date'
            },
            {
              key: 'tracking_code',
              as: 'Agent'
            },
            {
              key: 'status',
              as: 'Status',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: 'active',
              options: [
                {
                  value: 'all',
                  text: 'All'
                },
                {
                  value: 'active',
                  text: 'Active'
                },
                {
                  value: 'sold',
                  text: 'Sold'
                },
                {
                  value: 'expired',
                  text: 'Expired'
                },
                {
                  value: 'cancelled',
                  text: 'Cancelled'
                }
              ]
            },
            {
              key: 'application_id',
              as: 'Application ID'
            },
            {
              key: 'org',
              as: '',
              type: 'hidden',
              value: 'rimi'
            },
            {
              key: 'sources',
              as: 'Product',
              type: 'multiselect',
              options: [],
              col_width: 12,
            }
          ],
          msg: [
            {
              key: 'first_name',
              as: 'First Name'
            },
            {
              key: 'last_name',
              as: 'Last Name'
            },
            {
              key: 'date_of_birth',
              as: 'Date of Birth',
              format: 'date'
            },
            {
              key: 'policy_number',
              as: 'Policy Number',
              show_for: 'applicant'
            },
            {
              key: 'phone_number',
              as: 'Phone Number'
            },
            {
              key: 'email',
              as: 'Email'
            },
              {
              key: 'sale_date_from',
              as: 'Sale Date From',
              format: 'date',
              max_date: 'today'
            },
             {
              key: 'sale_date_to',
              as: 'Sale Date To',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'effective_date_from',
              as: 'Effective Date From',
              format: 'date'
            },
            {
              key: 'effective_date_to',
              as: 'Effective Date To',
              format: 'date'
            },
            {
              key: 'tracking_code',
              as: 'Agent'
            },
            {
              key: 'status',
              as: 'Status',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: 'active',
              options: [
                {
                  value: 'all',
                  text: 'All'
                },
                {
                  value: 'active',
                  text: 'Active'
                },
                {
                  value: 'sold',
                  text: 'Sold'
                },
                {
                  value: 'expired',
                  text: 'Expired'
                },
                {
                  value: 'cancelled',
                  text: 'Cancelled'
                }
              ]
            },
            {
              key: 'application_id',
              as: 'Application ID'
            },
            {
              key: 'org',
              as: '',
              type: 'hidden',
              value: 'msg'
            },
            {
              key: 'sources',
              as: 'Product',
              type: 'multiselect',
              options: [],
              col_width: 12,
            }
          ],
          visitcanada: [
            {
              key: 'first_name',
              as: 'First Name'
            },
            {
              key: 'last_name',
              as: 'Last Name'
            },
            {
              key: 'date_of_birth',
              as: 'Date of Birth',
              format: 'date'
            },
            {
              key: 'policy_number',
              as: 'Policy Number',
              show_for: 'applicant'
            },
            {
              key: 'phone_number',
              as: 'Phone Number'
            },
            {
              key: 'email',
              as: 'Email'
            },
              {
              key: 'sale_date_from',
              as: 'Sale Date From',
              format: 'date',
              max_date: 'today'
            },
             {
              key: 'sale_date_to',
              as: 'Sale Date To',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'effective_date_from',
              as: 'Effective Date From',
              format: 'date'
            },
            {
              key: 'effective_date_to',
              as: 'Effective Date To',
              format: 'date'
            },
            {
              key: 'tracking_code',
              as: 'Agent'
            },
            {
              key: 'status',
              as: 'Status',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: 'active',
              options: [
                {
                  value: 'all',
                  text: 'All'
                },
                {
                  value: 'active',
                  text: 'Active'
                },
                {
                  value: 'sold',
                  text: 'Sold'
                },
                {
                  value: 'expired',
                  text: 'Expired'
                },
                {
                  value: 'cancelled',
                  text: 'Cancelled'
                }
              ]
            },
            {
              key: 'application_id',
              as: 'Application ID'
            },
            {
              key: 'org',
              as: '',
              type: 'hidden',
              value: 'visitcanada'
            },
            {
              key: 'sources',
              as: 'Product',
              type: 'multiselect',
              options: [],
              col_width: 12,
            }
          ],
          insurecanada: [
            {
              key: 'first_name',
              as: 'First Name'
            },
            {
              key: 'last_name',
              as: 'Last Name'
            },
            {
              key: 'date_of_birth',
              as: 'Date of Birth',
              format: 'date'
            },
            {
              key: 'policy_number',
              as: 'Policy Number',
              show_for: 'applicant'
            },
            {
              key: 'phone_number',
              as: 'Phone Number'
            },
            {
              key: 'email',
              as: 'Email'
            },
              {
              key: 'sale_date_from',
              as: 'Sale Date From',
              format: 'date',
              max_date: 'today'
            },
             {
              key: 'sale_date_to',
              as: 'Sale Date To',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'effective_date_from',
              as: 'Effective Date From',
              format: 'date'
            },
            {
              key: 'effective_date_to',
              as: 'Effective Date To',
              format: 'date'
            },
            {
              key: 'tracking_code',
              as: 'Agent'
            },
            {
              key: 'status',
              as: 'Status',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: 'active',
              options: [
                {
                  value: 'all',
                  text: 'All'
                },
                {
                  value: 'active',
                  text: 'Active'
                },
                {
                  value: 'sold',
                  text: 'Sold'
                },
                {
                  value: 'expired',
                  text: 'Expired'
                },
                {
                  value: 'cancelled',
                  text: 'Cancelled'
                }
              ]
            },
            {
              key: 'application_id',
              as: 'Application ID'
            },
            {
              key: 'org',
              as: '',
              type: 'hidden',
              value: 'insurecanada'
            },
            {
              key: 'sources',
              as: 'Product',
              type: 'multiselect',
              options: [],
              col_width: 12,
            }
          ],
        },
        quote: {
          ingle: [
            {
              key: 'reference_id',
              as: 'Quote Number',
            },
            {
              key: 'created_at',
              as: 'Quote Date',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'first_name',
              as: 'First Name',
            },
            {
              key: 'last_name',
              as: 'Last Name',
            },
            {
              key: 'dob',
              as: 'Date of Birth',
              format: 'date'
            },
            {
              key: 'email',
              as: 'Email',
            },
            {
              key: 'effective_date',
              as: 'Effective Date',
              format: 'date'
            },
            {
              key: 'expiry_date',
              as: 'Expiry Date',
              format: 'date'
            },
            {
              key: 'tracking_code',
              as: 'Referrer',
            },
            {
              key: 'insurer',
              as: 'Underwriter',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: 'all',
              options: [
                {value: 'all', text:'All'},
                {value: 'lloyds', text:'Lloyd\'s'},
                {value: 'berkley', text:'Berkley'}
              ]
            },
            {
             key: 'org',
             as: '',
             type: 'hidden',
             value: 'rimi'
            },
            {
              key: 'sources',
              as: 'Product',
              type: 'multiselect',
              options: [],
              col_width: 12,
            }
          ],
          rimi: [
            {
              key: 'reference_id',
              as: 'Quote Number',
            },
            {
              key: 'created_at',
              as: 'Quote Date',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'first_name',
              as: 'First Name',
            },
            {
              key: 'last_name',
              as: 'Last Name',
            },
            {
              key: 'dob',
              as: 'Date of Birth',
              format: 'date'
            },
            {
              key: 'email',
              as: 'Email',
            },
            {
              key: 'effective_date',
              as: 'Effective Date',
              format: 'date'
            },
            {
              key: 'expiry_date',
              as: 'Expiry Date',
              format: 'date'
            },
            {
              key: 'tracking_code',
              as: 'Agent',
            },
            {
             key: 'org',
             as: '',
             type: 'hidden',
             value: 'rimi'
            },
            {
              key: 'sources',
              as: 'Product',
              type: 'multiselect',
              options: [],
              col_width: 12,
            }
          ],
          msg: [
            {
              key: 'reference_id',
              as: 'Quote Number',
            },
            {
              key: 'created_at',
              as: 'Quote Date',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'first_name',
              as: 'First Name',
            },
            {
              key: 'last_name',
              as: 'Last Name',
            },
            {
              key: 'dob',
              as: 'Date of Birth',
              format: 'date'
            },
            {
              key: 'email',
              as: 'Email',
            },
            {
              key: 'effective_date',
              as: 'Effective Date',
              format: 'date'
            },
            {
              key: 'expiry_date',
              as: 'Expiry Date',
              format: 'date'
            },
            {
              key: 'tracking_code',
              as: 'Agent',
            },
            {
             key: 'org',
             as: '',
             type: 'hidden',
             value: 'rimi'
            },
            {
              key: 'sources',
              as: 'Product',
              type: 'multiselect',
              options: [],
              col_width: 12,
            }
          ],
          visitcanada: [
            {
              key: 'reference_id',
              as: 'Quote Number',
            },
            {
              key: 'created_at',
              as: 'Quote Date',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'first_name',
              as: 'First Name',
            },
            {
              key: 'last_name',
              as: 'Last Name',
            },
            {
              key: 'dob',
              as: 'Date of Birth',
              format: 'date'
            },
            {
              key: 'email',
              as: 'Email',
            },
            {
              key: 'effective_date',
              as: 'Effective Date',
              format: 'date'
            },
            {
              key: 'expiry_date',
              as: 'Expiry Date',
              format: 'date'
            },
            {
              key: 'tracking_code',
              as: 'Agent',
            },
            {
             key: 'org',
             as: '',
             type: 'hidden',
             value: 'visitcanada'
            },
            {
              key: 'sources',
              as: 'Product',
              type: 'multiselect',
              options: [],
              col_width: 12,
            }
          ],
          insurecanada: [
            {
              key: 'reference_id',
              as: 'Quote Number',
            },
            {
              key: 'created_at',
              as: 'Quote Date',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'first_name',
              as: 'First Name',
            },
            {
              key: 'last_name',
              as: 'Last Name',
            },
            {
              key: 'dob',
              as: 'Date of Birth',
              format: 'date'
            },
            {
              key: 'email',
              as: 'Email',
            },
            {
              key: 'effective_date',
              as: 'Effective Date',
              format: 'date'
            },
            {
              key: 'expiry_date',
              as: 'Expiry Date',
              format: 'date'
            },
            {
              key: 'tracking_code',
              as: 'Agent',
            },
            {
             key: 'org',
             as: '',
             type: 'hidden',
             value: 'insurecanada'
            },
            {
              key: 'sources',
              as: 'Product',
              type: 'multiselect',
              options: [],
              col_width: 12,
            }
          ],
        },
        report: {
          ingle: [
            {
              key: 'report_type',
              as: 'Report Type',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: 'all',
              options: [
                {value: 'all', text:'All'},
                {value: 'History', text: 'Sales'},
                {value: 'Update', text: 'Change'},
              ]
            },
            {
              key: 'created_at',
              as: 'Report Date',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'first_name',
              as: 'First Name',
            },
            {
              key: 'last_name',
              as: 'Last Name',
            },
            {
              key: 'status',
              as: 'Status',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: 'all',
              options: [
                {value: 'all', text:'All'},
                {value: 'completed', text:'Completed'},
                {value: 'failed', text:'Failed'}
              ]
            },
            {
              key: 'user_id',
              as: 'User',
              type: 'dropdown',
              hideNullOption: true,
              options: [
                {value: 'all', text:'All'},
                {value: '', text:'My reports'}
              ],
            },
            {
              key: 'sources',
              as: 'Product',
              type: 'multiselect',
              options: [],
              col_width: 12,
            },
            {
             key: 'org',
             as: '',
             type: 'hidden',
             value: 'ingle'
            }
          ]
        },
        user: {
          ingle: [
            {
              key: 'first_name',
              as: 'First Name'
            },
            {
              key: 'last_name',
              as: 'Last Name'
            },
            {
              key: 'email',
              as: 'Email'
            },
            {
              key: 'csr_token',
              as: 'Agent Code'
            },
            {
              key: 'created_after',
              as: 'Created After',
              format: 'date'
            },
            {
              key: 'created_before',
              as: 'Created Before',
              format: 'date'
            },
            {
              key: 'company',
              as: 'Company'
            },
            {
              key: 'access_level',
              as: 'User Type',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: '',
              options: [
                {
                  value: '',
                  text: 'All'
                },
                {
                  value: 'superadmin',
                  text: 'Super Admin'
                },
                {
                  value: 'admin',
                  text: 'Admin'
                },
                {
                  value: 'schooladmin',
                  text: 'School Admin'
                },
                {
                  value: 'schoolsuperadmin',
                  text: 'School Super Admin'
                },
                {
                  value: 'groupadmin',
                  text: 'Group Admin'
                },
                {
                  value: 'agent',
                  text: 'Agent'
                },
                {
                  value: 'readonly',
                  text: 'Read Only'
                }
              ]
            },
            {
              key: 'status',
              as: 'Status',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: 'active',
              options: [
                {
                  value: '',
                  text: 'All'
                },
                {
                  value: 'active',
                  text: 'Active'
                },
                {
                  value: 'inactive',
                  text: 'Inactive'
                }
              ]
            },
            {
              key: 'school',
              as: 'Primary School Code',
              type: 'dropdown',
              saved_options_state: 'optionsCmsSchools',
              options_url: 'allCmsSchools',
            },
          ],
          rimi: [
            {
              key: 'first_name',
              as: 'First Name'
            },
            {
              key: 'last_name',
              as: 'Last Name'
            },
            {
              key: 'email',
              as: 'Email'
            },
            {
              key: 'csr_token',
              as: 'Agent Code'
            },
            {
              key: 'created_after',
              as: 'Created After',
              format: 'date'
            },
            {
              key: 'created_before',
              as: 'Created Before',
              format: 'date'
            },
            {
              key: 'company',
              as: 'Company'
            },
            {
              key: 'access_level',
              as: 'User Type',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: '',
              options: [
                {
                  value: '',
                  text: 'All'
                },
                {
                  value: 'admin',
                  text: 'Admin'
                },
                {
                  value: 'mga',
                  text: 'Mga'
                },
                {
                  value: 'agent',
                  text: 'Agent'
                },
                {
                  value: 'readonly',
                  text: 'Read Only'
                }
              ]
            },
            {
              key: 'status',
              as: 'Status',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: 'active',
              options: [
                {
                  value: '',
                  text: 'All'
                },
                {
                  value: 'active',
                  text: 'Active'
                },
                {
                  value: 'inactive',
                  text: 'Inactive'
                }
              ]
            },
          ],
          msg: [
            {
              key: 'first_name',
              as: 'First Name'
            },
            {
              key: 'last_name',
              as: 'Last Name'
            },
            {
              key: 'email',
              as: 'Email'
            },
            {
              key: 'csr_token',
              as: 'Agent Code'
            },
            {
              key: 'created_after',
              as: 'Created After',
              format: 'date'
            },
            {
              key: 'created_before',
              as: 'Created Before',
              format: 'date'
            },
            {
              key: 'company',
              as: 'Company'
            },
            {
              key: 'access_level',
              as: 'User Type',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: '',
              options: [
                {
                  value: '',
                  text: 'All'
                },
                {
                  value: 'admin',
                  text: 'MGA'
                },
                {
                  value: 'agent',
                  text: 'Sub-Agent'
                }
              ]
            },
            {
              key: 'status',
              as: 'Status',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: 'active',
              options: [
                {
                  value: '',
                  text: 'All'
                },
                {
                  value: 'active',
                  text: 'Active'
                },
                {
                  value: 'inactive',
                  text: 'Inactive'
                }
              ]
            },
          ],
          visitcanada: [
            {
              key: 'first_name',
              as: 'First Name'
            },
            {
              key: 'last_name',
              as: 'Last Name'
            },
            {
              key: 'email',
              as: 'Email'
            },
            {
              key: 'csr_token',
              as: 'Agent Code'
            },
            {
              key: 'created_after',
              as: 'Created After',
              format: 'date'
            },
            {
              key: 'created_before',
              as: 'Created Before',
              format: 'date'
            },
            {
              key: 'company',
              as: 'Company'
            },
            {
              key: 'access_level',
              as: 'User Type',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: '',
              options: [
                {
                  value: '',
                  text: 'All'
                },
                {
                  value: 'admin',
                  text: 'Admin'
                },
                {
                  value: 'mga',
                  text: 'Mga'
                },
                {
                  value: 'agent',
                  text: 'Agent'
                },
                {
                  value: 'readonly',
                  text: 'Read Only'
                }
              ]
            },
            {
              key: 'status',
              as: 'Status',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: 'active',
              options: [
                {
                  value: '',
                  text: 'All'
                },
                {
                  value: 'active',
                  text: 'Active'
                },
                {
                  value: 'inactive',
                  text: 'Inactive'
                }
              ]
            },
          ],
          insurecanada: [
            {
              key: 'first_name',
              as: 'First Name'
            },
            {
              key: 'last_name',
              as: 'Last Name'
            },
            {
              key: 'email',
              as: 'Email'
            },
            {
              key: 'csr_token',
              as: 'Agent Code'
            },
            {
              key: 'created_after',
              as: 'Created After',
              format: 'date'
            },
            {
              key: 'created_before',
              as: 'Created Before',
              format: 'date'
            },
            {
              key: 'company',
              as: 'Company'
            },
            {
              key: 'access_level',
              as: 'User Type',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: '',
              options: [
                {
                  value: '',
                  text: 'All'
                },
                {
                  value: 'admin',
                  text: 'Admin'
                },
                {
                  value: 'mga',
                  text: 'Mga'
                },
                {
                  value: 'agent',
                  text: 'Agent'
                },
                {
                  value: 'readonly',
                  text: 'Read Only'
                }
              ]
            },
            {
              key: 'status',
              as: 'Status',
              type: 'dropdown',
              hideNullOption: true,
              defaultValue: 'active',
              options: [
                {
                  value: '',
                  text: 'All'
                },
                {
                  value: 'active',
                  text: 'Active'
                },
                {
                  value: 'inactive',
                  text: 'Inactive'
                }
              ]
            },
          ],
        },
        claim: {
          ingle: [
            {
              key: 'first_name',
              as: 'First Name'
            },
            {
              key: 'last_name',
              as: 'Last Name'
            },
            {
              key: 'email',
              as: 'Email'
            },
            {
              key: 'policy_number',
              as: 'Policy Number'
            },
            {
              key: 'claim_id',
              as: 'Submission ID'
            },
            {
              key: 'created_at',
              as: 'Submitted On',
              format: 'date'
            },
          ],
        },
        bulkuploadlist: {
          ingle: [
            {
              key: 'created_at',
              as: 'Date Created',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'email',
              as: 'Uploader Email',
            },
            {
              key: 'sources',
              as: 'Product',
              type: 'multiselect',
              options: [],
              col_width: 12,
            }
          ]
        },
      },
      reports: {
        policies: {
          ingle: [
            {
              key: 'source_id',
              as: 'Product',
              type: 'dropdown',
              options: [],
            },
            {
              key: 'report_type',
              as: 'Report Type',
              type: 'dropdown',
                options: [
                  {value: 'History', text: 'Sales'},
                  {value: 'Update', text: 'Change'},
                ],
            },
            {
              key: 'start_date',
              as: 'Start Date',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'end_date',
              as: 'End Date',
              format: 'date',
              max_date: 'today'
            },
            {
              key: 'email_to',
              as: 'Email To',
            },
            {
              key: 'email_cc',
              as: 'Email CC',
              can_be_empty: true
            }
          ]
        }
      },
      listing: {
        applicant: [
          {label: 'Policy No.', col_sm:1},
          {label: 'Status', col_sm:1},
          {label: 'First Name'},
          {label: 'Last Name'},
          {label: 'Date of Birth', col_sm:1},
          {label: 'Eff. Date', sortable: true, col_sm:1, field_name: 'effective_date'},
          {label: 'Exp. Date', sortable: true, col_sm:1, field_name: 'expiry_date'},
          ...(checkAccessLevel('viewonly') ? [] : [{label: 'Premium', col_sm:1}]),
          {label: 'Product Name', col_sm:3},
        ],
        user: [
          {label: 'Agent Code'},
          {label: 'First Name'},
          {label: 'Last Name'},
          {label: 'Email'},
          {label: 'User Type'},
          {label: 'Status'},
        ],
        quote: [
          {label: 'Quote Number'},
          {label: 'Status', col_sm:1},
          {label: 'First Name'},
          {label: 'Last Name'},
          {label: 'Date of Birth', col_sm:1},
          {label: 'Quote Date', col_sm:1},
          {label: 'Product Name', col_sm:3},
        ],
        report: [
          {label: 'Report Date', col_sm:1},
          {label: 'Status', col_sm:1},
          {label: 'Report Type', col_sm:1},
          {label: 'First Name'},
          {label: 'Last Name'},
          {label: 'Product Name', col_sm:3},
        ],
        claim: [
          {label: 'Submission ID'},
          {label: 'Policy Number'},
          {label: 'First Name'},
          {label: 'Last Name'},
          {label: 'Submitted On'},
        ],
        bulkuploadlist: [
          {label: 'Product Name'},
          {label: 'Date Created', col_sm:1},
          {label: 'Policies Uploaded', col_sm:1},
          {label: 'Completed', col_sm:1},
          {label: 'Failed', col_sm:1},
          {label: 'Queued', col_sm:1},
          {label: 'School', col_sm:1},
          {label: 'Uploader', col_sm:1},
          {label: 'Status', col_sm:1},
        ],
        uploaddetails: [
          {label: 'Policy Number'},
          {label: 'Status', col_sm:1},
          {label: 'First Name'},
          {label: 'Last Name'},
          {label: 'Date of Birth', col_sm:1},
          {label: 'Effective Date'},
          {label: 'Expiry Date'},
        ],
      },
      bulkuploadlist: {
        ingle: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'email'],
                  as: 'Uploader Email'
                },
              ]
            }
          ],
        }
      },
      uploaddetails: {
        ingle: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'sale_date'],
                  as: 'Sale Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'effective_date'],
                  as: 'Effective Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'expiry_date'],
                  as: 'Expiry Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'tracking_code'],
                  as: 'Referrer',
                }
              ]
            }
          ],
        }
      },
      applicant: {
        rimi: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'application', 'sale_date'],
                  as: 'Sale Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'effective_date'],
                  as: 'Effective Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'expiry_date'],
                  as: 'Expiry Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'premium'],
                  as: 'Premium',
                  format: 'currency',
                  do_not_show_if: [{
                    key_path: ['search', 'application', 'premium'],
                    value: undefined
                  }]
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'tracking_code'],
                  as: 'Agent',
                }
              ]
            }
          ],
        },
        ingle: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'application', 'sale_date'],
                  as: 'Sale Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'effective_date'],
                  as: 'Effective Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'expiry_date'],
                  as: 'Expiry Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'premium'],
                  as: 'Premium',
                  format: 'currency',
                  do_not_show_if: [{
                    key_path: ['search', 'application', 'premium'],
                    value: undefined
                  }]
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'tracking_code'],
                  as: 'Referrer',
                  is_static_by_default: true
                },
                {
                  key_path: ['search', 'school_name'],
                  as: 'School',
                  do_not_show_if: [{
                    key_path: ['search', 'application', 'source'],
                    values: ['lloydsascnoop', 'lloydsascnallincl', 'lloydsascnnonmed', 'lloydscanuckvoyage', 'lloydsdiscovercanada', 'tpageneric', 'blanket']
                  }],
                }
              ]
            }
          ],
        },
        msg: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'application', 'sale_date'],
                  as: 'Sale Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'effective_date'],
                  as: 'Effective Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'expiry_date'],
                  as: 'Expiry Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'premium'],
                  as: 'Premium',
                  format: 'currency',
                  do_not_show_if: [{
                    key_path: ['search', 'application', 'premium'],
                    value: undefined
                  }]
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'tracking_code'],
                  as: 'Agent',
                }
              ]
            }
          ],
        },
        visitcanada: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'application', 'sale_date'],
                  as: 'Sale Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'effective_date'],
                  as: 'Effective Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'expiry_date'],
                  as: 'Expiry Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'premium'],
                  as: 'Premium',
                  format: 'currency',
                  do_not_show_if: [{
                    key_path: ['search', 'application', 'premium'],
                    value: undefined
                  }]
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'tracking_code'],
                  as: 'Agent',
                }
              ]
            }
          ],
        },
        insurecanada: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'application', 'sale_date'],
                  as: 'Sale Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'effective_date'],
                  as: 'Effective Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'expiry_date'],
                  as: 'Expiry Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'premium'],
                  as: 'Premium',
                  format: 'currency',
                  do_not_show_if: [{
                    key_path: ['search', 'application', 'premium'],
                    value: undefined
                  }]
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'tracking_code'],
                  as: 'Agent',
                }
              ]
            }
          ],
        },
      },
      quote: {
        rimi: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'email'],
                  as: 'Email',
                },
                {
                  key_path: ['search', 'application', 'effective_date'],
                  as: 'Effective Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'expiry_date'],
                  as: 'Expiry Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'tracking_code'],
                  as: 'Agent',
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'quote_premium'],
                  as: 'Quoted Premium',
                  format: 'currency',
                  do_not_show_if: [{
                    key_path: ['search', 'application', 'additional_data', 'quote_premium'],
                    value: undefined
                  }]
                }
              ]
            }
          ],
        },
        ingle: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'application', 'quote_date'],
                  as: 'Quote Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'effective_date'],
                  as: 'Effective Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'expiry_date'],
                  as: 'Expiry Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'tracking_code'],
                  as: 'Referrer',
                  is_static_by_default: true
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'quote_premium'],
                  as: 'Quoted Premium',
                  format: 'currency',
                  do_not_show_if: [{
                    key_path: ['search', 'application', 'additional_data', 'quote_premium'],
                    value: undefined
                  }]
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'sales_tax'],
                  as: 'Sales Tax',
                  format: 'currency',
                  do_not_show_if: [{
                    key_path: ['search', 'application', 'additional_data', 'sales_tax'],
                    value: undefined
                  }]
                }
              ]
            }
          ],
        },
        msg: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'email'],
                  as: 'Email',
                },
                {
                  key_path: ['search', 'application', 'effective_date'],
                  as: 'Effective Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'expiry_date'],
                  as: 'Expiry Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'tracking_code'],
                  as: 'Agent',
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'quote_premium'],
                  as: 'Quoted Premium',
                  format: 'currency',
                  do_not_show_if: [{
                    key_path: ['search', 'application', 'additional_data', 'quote_premium'],
                    value: undefined
                  }]
                }
              ]
            }
          ],
        },
        visitcanada: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'email'],
                  as: 'Email',
                },
                {
                  key_path: ['search', 'application', 'effective_date'],
                  as: 'Effective Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'expiry_date'],
                  as: 'Expiry Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'tracking_code'],
                  as: 'Agent',
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'quote_premium'],
                  as: 'Quoted Premium',
                  format: 'currency',
                  do_not_show_if: [{
                    key_path: ['search', 'application', 'additional_data', 'quote_premium'],
                    value: undefined
                  }]
                }
              ]
            }
          ],
        },
        insurecanada: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'email'],
                  as: 'Email',
                },
                {
                  key_path: ['search', 'application', 'effective_date'],
                  as: 'Effective Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'expiry_date'],
                  as: 'Expiry Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'tracking_code'],
                  as: 'Agent',
                },
                {
                  key_path: ['search', 'application', 'additional_data', 'quote_premium'],
                  as: 'Quoted Premium',
                  format: 'currency',
                  do_not_show_if: [{
                    key_path: ['search', 'application', 'additional_data', 'quote_premium'],
                    value: undefined
                  }]
                }
              ]
            }
          ],
        },
      },
      report: {
        ingle: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'email_to'],
                  as: 'Email To',
                },
                {
                  key_path: ['search', 'start_date'],
                  as: 'Start Date',
                  format: 'date'
                },
                {
                  key_path: ['search', 'end_date'],
                  as: 'End Date',
                  format: 'date'
                },

              ]
            }
          ],
        }
      },
      user: {
        rimi: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'data', 'company'],
                  as: 'Company'
                },
                {
                  key_path: ['search', 'email'],
                  as: 'Email'
                },
                {
                  key_path: ['search', 'date_created'],
                  as: 'Date Created'
                }
              ]
            }
          ],
          expanded: [
            {
              group_name: 'User Information',
              check_history: false,
              fields: [
                {
                  key_path: ['user', 'first_name'],
                  as: 'First Name',
                },
                {
                  key_path: ['user', 'last_name'],
                  as: 'Last Name',
                },
                {
                  key_path: ['user', 'email'],
                  as: 'Email',
                },
                {
                  key_path: ['user', 'data', 'csr_token'],
                  as: 'Agent Code',
                  edit_restricted: true,
                  is_permanent: true
                },
                {
                  key_path: ['user', 'data', 'company'],
                  as: 'Company',
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'access_level'],
                  as: 'User Type',
                  type: 'dropdown',
                  options: [
                    {value: 'admin', text: 'Admin'},
                    {value: 'mga', text: 'MGA'},
                    {value: 'agent', text: 'Agent'},
                    {value: 'readonly', text: 'Read Only'},
                  ],
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'status'],
                  as: 'Status',
                  type: 'radio',
                  options: [
                    {value: 'active', text: 'Active'},
                    {value: 'inactive', text: 'Inactive'},
                  ],
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'password'],
                  as: 'Password',
                  format: 'password'
                },
                {
                  key_path: ['user', 'data', 'agent_commission'],
                  as: 'Agent Commission',
                  format: 'percentage',
                  hidden_to_non_admin: true,
                  show_if: [{
                    key_path: ['user', 'access_level'],
                    value: 'agent'
                  },
                  {
                    key_path: ['user', 'access_level'],
                    value: 'mga'
                  }]
                },
                {
                  key_path: ['user', 'data', 'agent_codes'],
                  as: 'Agent Codes',
                  type: 'checkboxgroup',
                  format: 'multivalue',
                  saved_options_state: 'agentCodes',
                  options_url: 'agentCodes',
                  show_if: [{
                    key_path: ['user', 'access_level'],
                    value: 'mga'
                  }],
                  edit_restricted: true,
                  show_filter: true
                },
              ]
            },
            {
              group_name: 'User Permissions',
              hidden: false,
              check_history: false,
              hide_in_create_mode: true,
              restricted_access: ['agent'],
              fields: [
                {
                  key_path: ['user', 'scopes'],
                  as: 'Permissions',
                  type: 'checkboxgroup',
                  options: [
                    {value: 'ingle.insurance.superadmin', text: 'Modify policies after effective date'},
                    {value: 'ingle.insurance.agent', text: 'View User Policies Only'},
                    {value: 'ingle.insurance.admin_readonly', text: 'Read Only'},
                    {value: 'novus.admin', text: 'Manage Users'},
                    {value: 'bulkupload', text: 'Bulk Enrolment'},
                  ],
                  edit_restricted: true
                }
              ]
            }
          ]
        },
        ingle: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'email'],
                  as: 'Email'
                },
                {
                  key_path: ['search', 'date_created'],
                  as: 'Date Created'
                }
              ]
            }
          ],
          expanded: [
            {
              group_name: 'User Information',
              check_history: false,
              fields: [
                {
                  key_path: ['user', 'first_name'],
                  as: 'First Name',
                },
                {
                  key_path: ['user', 'last_name'],
                  as: 'Last Name',
                },
                {
                  key_path: ['user', 'email'],
                  as: 'Email',
                },
                {
                  key_path: ['user', 'data', 'csr_token'],
                  as: 'Agent Code',
                  edit_restricted: true,
                  is_permanent: true
                },
                {
                  key_path: ['user', 'data', 'company'],
                  as: 'Company',
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'access_level'],
                  as: 'User Type',
                  type: 'dropdown',
                  options: [
                    {value: 'superadmin', text: 'Super Admin'},
                    {value: 'admin', text: 'Admin'},
                    {value: 'schooladmin', text: 'School Admin'},
                    {value: 'schoolsuperadmin', text: 'School Super Admin'},
                    {value: 'groupadmin', text: 'Group Admin'},
                    {value: 'agent', text: 'Agent'},
                    {value: 'readonly', text: 'Read Only'},
                  ],
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'status'],
                  as: 'Status',
                  type: 'radio',
                  options: [
                    {value: 'active', text: 'Active'},
                    {value: 'inactive', text: 'Inactive'},
                  ],
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'password'],
                  as: 'Password',
                  format: 'password'
                },
                {
                  key_path: ['user', 'data', 'school'],
                  as: 'Primary School Code',
                  type: 'dropdown',
                  saved_options_state: 'optionsCmsSchools',
                  options_url: 'allCmsSchools',
                  show_if: [{
                    key_path: ['user', 'access_level'],
                    values: ['schooladmin', 'schoolsuperadmin']
                  }],
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'data', 'all_schools'],
                  as: 'All School Codes',
                  type: 'checkboxgroup',
                  format: 'multivalue',
                  saved_options_state: 'optionsCmsSchools',
                  options_url: 'allCmsSchools',
                  show_if: [{
                    key_path: ['user', 'access_level'],
                    values: ['schooladmin', 'schoolsuperadmin']
                  }],
                  edit_restricted: true,
                  show_filter: true
                },
                {
                  key_path: ['user', 'data', 'school'],
                  as: 'Group Code',
                  type: 'dropdown',
                  saved_options_state: 'optionsCmsSchools',
                  options_url: 'allCmsSchools',
                  show_if: [{
                    key_path: ['user', 'access_level'],
                    value: 'groupadmin'
                  }],
                  edit_restricted: true
                },
              ]
            },
            {
              group_name: 'User Permissions',
              hidden: false,
              check_history: false,
              hide_in_create_mode: true,
              restricted_access: ['agent', 'schooladmin', 'schoolsuperadmin', 'groupadmin', 'viewonly'],
              fields: [
                {
                  key_path: ['user', 'scopes'],
                  as: 'Permissions',
                  type: 'checkboxgroup',
                  options: [
                    {value: 'ingle.insurance.superadmin', text: 'Super Admin'},
                    {value: 'ingle.insurance.admin', text: 'Admin'},
                    {value: 'ingle.insurance.schooladmin', text: 'School Admin'},
                    {value: 'ingle.insurance.schooladmin', text: 'Group Admin'},
                    {value: 'ingle.insurance.schoolsuperadmin', text: 'School Super Admin'},
                    {value: 'ingle.insurance.admin_readonly', text: 'Read Only'},
                    {value: 'ingle.insurance.agent', text: 'View User Policies Only'},
                    {value: 'ingle.insurance.admin.overridepremium', text: 'Premium Override'},
                    {value: 'novus.admin', text: 'User Admin'},
                    {value: 'bulkupload', text: 'Bulk Enrolment'},
                    {value: 'viewonly', text: 'View Policies Only'},
                    {value: 'view_claims', text: 'View Claims'},
                  ],
                  edit_restricted: true
                }
              ]
            }
          ]
        },
        msg: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'data', 'company'],
                  as: 'Company'
                },
                {
                  key_path: ['search', 'email'],
                  as: 'Email'
                },
                {
                  key_path: ['search', 'date_created'],
                  as: 'Date Created'
                }
              ]
            }
          ],
          expanded: [
            {
              group_name: 'User Information',
              check_history: false,
              fields: [
                {
                  key_path: ['user', 'first_name'],
                  as: 'First Name',
                },
                {
                  key_path: ['user', 'last_name'],
                  as: 'Last Name',
                },
                {
                  key_path: ['user', 'email'],
                  as: 'Email',
                },
                {
                  key_path: ['user', 'data', 'csr_token'],
                  as: 'Agent Code',
                  edit_restricted: true,
                  is_permanent: true
                },
                {
                  key_path: ['user', 'data', 'company'],
                  as: 'Company',
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'access_level'],
                  as: 'User Type',
                  type: 'dropdown',
                  options: [
                    {value: 'admin', text: 'MGA'},
                    {value: 'agent', text: 'Sub-Agent'},
                  ],
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'status'],
                  as: 'Status',
                  type: 'radio',
                  options: [
                    {value: 'active', text: 'Active'},
                    {value: 'inactive', text: 'Inactive'},
                  ],
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'password'],
                  as: 'Password',
                  format: 'password'
                }
              ]
            },
            {
              group_name: 'User Permissions',
              hidden: false,
              check_history: false,
              hide_in_create_mode: true,
              restricted_access: ['agent'],
              fields: [
                {
                  key_path: ['user', 'scopes'],
                  as: 'Permissions',
                  type: 'checkboxgroup',
                  options: [
                    {value: 'ingle.insurance.superadmin', text: 'Modify policies after effective date'},
                    {value: 'ingle.insurance.agent', text: 'View User Policies Only'},
                    {value: 'ingle.insurance.admin_readonly', text: 'Read Only'},
                    {value: 'novus.admin', text: 'Manage Users'},
                    {value: 'bulkupload', text: 'Bulk Enrolment'},
                  ],
                  edit_restricted: true
                }
              ]
            }
          ]
        },
        visitcanada: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'data', 'company'],
                  as: 'Company'
                },
                {
                  key_path: ['search', 'email'],
                  as: 'Email'
                },
                {
                  key_path: ['search', 'date_created'],
                  as: 'Date Created'
                }
              ]
            }
          ],
          expanded: [
            {
              group_name: 'User Information',
              check_history: false,
              fields: [
                {
                  key_path: ['user', 'first_name'],
                  as: 'First Name',
                },
                {
                  key_path: ['user', 'last_name'],
                  as: 'Last Name',
                },
                {
                  key_path: ['user', 'email'],
                  as: 'Email',
                },
                {
                  key_path: ['user', 'data', 'csr_token'],
                  as: 'Agent Code',
                  edit_restricted: true,
                  is_permanent: true
                },
                {
                  key_path: ['user', 'data', 'company'],
                  as: 'Company',
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'access_level'],
                  as: 'User Type',
                  type: 'dropdown',
                  options: [
                    {value: 'admin', text: 'Admin'},
                    {value: 'mga', text: 'MGA'},
                    {value: 'agent', text: 'Agent'},
                    {value: 'readonly', text: 'Read Only'},
                  ],
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'status'],
                  as: 'Status',
                  type: 'radio',
                  options: [
                    {value: 'active', text: 'Active'},
                    {value: 'inactive', text: 'Inactive'},
                  ],
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'password'],
                  as: 'Password',
                  format: 'password'
                },
                {
                  key_path: ['user', 'data', 'agent_commission'],
                  as: 'Agent Commission',
                  format: 'percentage',
                  hidden_to_non_admin: true,
                  show_if: [{
                    key_path: ['user', 'access_level'],
                    value: 'agent'
                  },
                  {
                    key_path: ['user', 'access_level'],
                    value: 'mga'
                  }]
                },
                {
                  key_path: ['user', 'data', 'agent_codes'],
                  as: 'Agent Codes',
                  type: 'checkboxgroup',
                  format: 'multivalue',
                  saved_options_state: 'agentCodes',
                  options_url: 'agentCodes',
                  show_if: [{
                    key_path: ['user', 'access_level'],
                    value: 'mga'
                  }],
                  edit_restricted: true,
                  show_filter: true
                },
              ]
            },
            {
              group_name: 'User Permissions',
              hidden: false,
              check_history: false,
              hide_in_create_mode: true,
              restricted_access: ['agent'],
              fields: [
                {
                  key_path: ['user', 'scopes'],
                  as: 'Permissions',
                  type: 'checkboxgroup',
                  options: [
                    {value: 'ingle.insurance.superadmin', text: 'Modify policies after effective date'},
                    {value: 'ingle.insurance.agent', text: 'View User Policies Only'},
                    {value: 'ingle.insurance.admin_readonly', text: 'Read Only'},
                    {value: 'novus.admin', text: 'Manage Users'},
                    {value: 'bulkupload', text: 'Bulk Enrolment'},
                  ],
                  edit_restricted: true
                }
              ]
            }
          ]
        },
        insurecanada: {
          compact: [
            {
              group_name: 'Details',
              fields: [
                {
                  key_path: ['search', 'data', 'company'],
                  as: 'Company'
                },
                {
                  key_path: ['search', 'email'],
                  as: 'Email'
                },
                {
                  key_path: ['search', 'date_created'],
                  as: 'Date Created'
                }
              ]
            }
          ],
          expanded: [
            {
              group_name: 'User Information',
              check_history: false,
              fields: [
                {
                  key_path: ['user', 'first_name'],
                  as: 'First Name',
                },
                {
                  key_path: ['user', 'last_name'],
                  as: 'Last Name',
                },
                {
                  key_path: ['user', 'email'],
                  as: 'Email',
                },
                {
                  key_path: ['user', 'data', 'csr_token'],
                  as: 'Agent Code',
                  edit_restricted: true,
                  is_permanent: true
                },
                {
                  key_path: ['user', 'data', 'company'],
                  as: 'Company',
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'access_level'],
                  as: 'User Type',
                  type: 'dropdown',
                  options: [
                    {value: 'admin', text: 'Admin'},
                    {value: 'mga', text: 'MGA'},
                    {value: 'agent', text: 'Agent'},
                    {value: 'readonly', text: 'Read Only'},
                  ],
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'status'],
                  as: 'Status',
                  type: 'radio',
                  options: [
                    {value: 'active', text: 'Active'},
                    {value: 'inactive', text: 'Inactive'},
                  ],
                  edit_restricted: true
                },
                {
                  key_path: ['user', 'password'],
                  as: 'Password',
                  format: 'password'
                },
                {
                  key_path: ['user', 'data', 'agent_commission'],
                  as: 'Agent Commission',
                  format: 'percentage',
                  hidden_to_non_admin: true,
                  show_if: [{
                    key_path: ['user', 'access_level'],
                    value: 'agent'
                  },
                  {
                    key_path: ['user', 'access_level'],
                    value: 'mga'
                  }]
                },
                {
                  key_path: ['user', 'data', 'agent_codes'],
                  as: 'Agent Codes',
                  type: 'checkboxgroup',
                  format: 'multivalue',
                  saved_options_state: 'agentCodes',
                  options_url: 'agentCodes',
                  show_if: [{
                    key_path: ['user', 'access_level'],
                    value: 'mga'
                  }],
                  edit_restricted: true,
                  show_filter: true
                },
              ]
            },
            {
              group_name: 'User Permissions',
              hidden: false,
              check_history: false,
              hide_in_create_mode: true,
              restricted_access: ['agent'],
              fields: [
                {
                  key_path: ['user', 'scopes'],
                  as: 'Permissions',
                  type: 'checkboxgroup',
                  options: [
                    {value: 'ingle.insurance.superadmin', text: 'Modify policies after effective date'},
                    {value: 'ingle.insurance.agent', text: 'View User Policies Only'},
                    {value: 'ingle.insurance.admin_readonly', text: 'Read Only'},
                    {value: 'novus.admin', text: 'Manage Users'},
                    {value: 'bulkupload', text: 'Bulk Enrolment'},
                  ],
                  edit_restricted: true
                }
              ]
            }
          ]
        },
      },
      contact_us: {
        ingle: {
          field_groups: [
            {
              group_name: 'User Information',
              check_history: false,
              fields: [
                {
                  key_path: ['first_name'],
                  as: 'First Name',
                },
                {
                  key_path: ['last_name'],
                  as: 'Last Name',
                },
                {
                  key_path: ['email'],
                  as: 'Email',
                },
                {
                  key_path: ['enquiry_type'],
                  as: 'Type of Enquiry',
                  type: 'dropdown',
                  options: [
                    {value: 'General Enquiries', text: 'General Enquiries'},
                    {value: 'Website Feedback', text: 'Website Feedback'},
                    {value: 'Get a Quote', text: 'Get a Quote'},
                    {value: 'Policy Change Request', text: 'Policy Change Request'},
                    {value: 'Policy Cancellation Request', text: 'Policy Cancellation Request'},
                  ],
                  edit_restricted: true
                },

              ]
            },
            {
              group_name: 'Message',
              check_history: false,
              fields: [
              {
                key_path: ['body'],
                as: 'Message',
                format: 'textarea',
              }]
            },
          ]
        }
      },
      claim: {
        compact: [
          {
            group_name: 'Details',
            fields: [
              {
                key_path: ['search', 'email'],
                as: 'Email',
              },
              {
                key_path: ['search', 'site'],
                as: 'School',
              },
            ]
          }
        ],
        ingle: {
          field_groups: [
            {
              group_name: 'Claim Information',
              check_history: false,
              fields: [
                {
                  key_path: ['claim','claim_id'],
                  as: 'Submission ID',
                },
                {
                  key_path: ['claim','policy_number'],
                  as: 'Policy Number',
                },
                {
                  key_path: ['claim','first_name'],
                  as: 'First Name',
                },
                {
                  key_path: ['claim','last_name'],
                  as: 'Last Name',
                },
                {
                  key_path: ['claim','email'],
                  as: 'Email',
                },
                {
                  key_path: ['claim','site'],
                  as: 'School',
                },
                {
                  key_path: ['claim','created_at'],
                  as: 'Date Submitted',
                },
              ]
            },
            {
              group_name: 'Documents',
              addon: {
                name: 'document'
              }
            },
          ]
        }
      },
      clients: {
        // ...deprecatedClients(),
        lloydscanuckvoyage: {
          defaultEmail: null,
          partial_skip_validation: false,
          upload_path: [
            {
              canUpload: true,
              radioButtons: true,
              options: [
                {
                  value: 'email',
                  label: 'Separate Emails'
                },
                {
                  value: 'none',
                  label: 'No Fulfillment'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'lloydscanuckvoyage?'
            }
          ],
          configuration_form: configurationForm('lloydscanuckvoyage'),
        },
        lloydscomprehensiveplus: {
          defaultEmail: null,
          partial_skip_validation: false,
          hidePremium: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'zip',
                  label: 'Zip'
                },
                {
                  value: 'email',
                  label: 'Separate Emails'
                },
                {
                  value: 'print',
                  label: 'Print Format'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'lloydscomprehensiveplus?'
            }
          ],
          configuration_form: configurationForm('lloydscomprehensiveplus')
        },
        lloydsis: {
          defaultEmail: null,
          partial_skip_validation: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'zip',
                  label: 'Zip'
                },
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              name: 'Silver',
              link: 'lloydsis?coverage=silver'
            },
            {
              name: 'Gold',
              link: 'lloydsis?coverage=gold'
            },
          ],
          configuration_form: configurationForm('lloydsis'),
        },
        lloydsdiscovercanada: {
          defaultEmail: null,
          partial_skip_validation: false,
          // upload_path: uploadPathGroup(
          //   {
          //     canUpload: true,
          //     radioButtons: true,
          //     Fulfillment_options: {'email', 'none'}
          //   }
          // )
          upload_path: [
            {
              canUpload: true,
              radioButtons: true,
              options: [
                {
                  value: 'email',
                  label: 'Separate Emails'
                },
                {
                  value: 'none',
                  label: 'No Fulfillment'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'lloydsdiscovercanada?'
            }
          ],
          configuration_form: configurationForm('lloydsdiscovercanada')
        },
        lloydsexplorecanadais: {
          defaultEmail: null,
          partial_skip_validation: false,
          hidePremium: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'zip',
                  label: 'Zip'
                },
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'lloydsexplorecanadais?'
            }
          ],
          configuration_form: configurationForm('lloydsexplorecanadais')
        },
        lloydsstudycanadais: {
          defaultEmail: null,
          partial_skip_validation: false,
          hidePremium: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'zip',
                  label: 'Zip'
                },
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'lloydsstudycanadais?'
            }
          ],
          configuration_form: configurationForm('lloydsstudycanadais')
        },
        lloydsascnoop: {
          defaultEmail: null,
          partial_skip_validation: false,
          upload_path: [
            {
              canUpload: false
            }
          ],
          form_path: [
            {
              link: 'lloydsascnoop?'
            }
          ],
          configuration_form: configurationForm('lloydsascnoop'),
        },
        lloydsascnallincl: {
          defaultEmail: null,
          partial_skip_validation: false,
          upload_path: [
            {
              canUpload: false
            }
          ],
          form_path: [
            {
              link: 'lloydsascnallincl?'
            }
          ],
          configuration_form: configurationForm('lloydsascnallincl'),
        },
        lloydsascnnonmed: {
          defaultEmail: null,
          partial_skip_validation: false,
          upload_path: [
            {
              canUpload: false
            }
          ],
          form_path: [
            {
              link: 'lloydsascnnonmed?'
            }
          ],
          configuration_form: configurationForm('lloydsascnnonmed'),
        },
        lloydsessentialplanis: {
          defaultEmail: null,
          partial_skip_validation: false,
          hidePremium: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'zip',
                  label: 'Zip'
                },
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'lloydsessentialplanis?'
            }
          ],
          configuration_form: configurationForm('lloydsessentialplanis')
        },
        lloydsessentialworldwideplanis: {
          defaultEmail: null,
          partial_skip_validation: false,
          hidePremium: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'zip',
                  label: 'Zip'
                },
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'lloydsessentialworldwideplanis?'
            }
          ],
          configuration_form: configurationForm('lloydsessentialworldwideplanis')
        },
        lloydsusis: {
          defaultEmail: null,
          partial_skip_validation: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'zip',
                  label: 'Zip'
                },
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              name: 'Basic',
              link: 'lloydsusis?coverage=basic'
            },
            {
              name: 'Advantage',
              link: 'lloydsusis?coverage=advantage'
            },
            {
              name: 'Elite',
              link: 'lloydsusis?coverage=elite'
            }
          ],
          configuration_form: configurationForm('lloydsusis')
        },
        lloydsmycanadais: {
          defaultEmail: null,
          partial_skip_validation: false,
          hidePremium: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'zip',
                  label: 'Zip'
                },
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'lloydsmycanadais?'
            }
          ],
          configuration_form: configurationForm('lloydsmycanadais')
        },
        lloydsmycanadaplusis: {
          defaultEmail: null,
          partial_skip_validation: false,
          hidePremium: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'zip',
                  label: 'Zip'
                },
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'lloydsmycanadaplusis?'
            }
          ],
          configuration_form: configurationForm('lloydsmycanadaplusis')
        },
        lloydsoutboundstudent: {
          defaultEmail: null,
          partial_skip_validation: false,
          hidePremium: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'zip',
                  label: 'Zip'
                },
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'lloydsoutboundstudent?'
            }
          ],
          configuration_form: configurationForm('lloydsoutboundstudent')
        },
        lloydsetrstudent: {
          defaultEmail: null,
          partial_skip_validation: false,
          hidePremium: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'zip',
                  label: 'Zip'
                },
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'lloydsetrstudent?'
            }
          ],
          configuration_form: configurationForm('lloydsetrstudent')
        },
        msgascnallincl: {
          defaultEmail: null,
          partial_skip_validation: false,
          upload_path: [
            {
              canUpload: false
            }
          ],
          form_path: [
            {
              link: 'msgascnallincl?'
            }
          ],
          configuration_form: configurationForm('msgascnallincl'),
        },
        msgascnnonmed: {
          defaultEmail: null,
          partial_skip_validation: false,
          upload_path: [
            {
              canUpload: false
            }
          ],
          form_path: [
            {
              link: 'msgascnnonmed?'
            }
          ],
          configuration_form: configurationForm('msgascnnonmed'),
        },
        msgemergencymedical: {
          defaultEmail: null,
          partial_skip_validation: false,
          upload_path: [
            {
              canUpload: true,
              radioButtons: true,
              options: [
                {
                  value: 'email',
                  label: 'Separate Emails'
                },
                {
                  value: 'none',
                  label: 'No Fulfillment'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'msgemergencymedical?'
            }
          ],
          configuration_form: configurationForm('msgemergencymedical'),
        },
        msgis: {
          defaultEmail: null,
          partial_skip_validation: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'zip',
                  label: 'Zip'
                },
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              name: 'Silver',
              link: 'msgis?coverage=silver'
            },
            {
              name: 'Gold',
              link: 'msgis?coverage=gold'
            },
          ],
          configuration_form: configurationForm('msgis'),
        },
        msgvisitorstocanada: {
          defaultEmail: null,
          partial_skip_validation: false,
          upload_path: [
            {
              canUpload: true,
              radioButtons: true,
              options: [
                {
                  value: 'email',
                  label: 'Separate Emails'
                },
                {
                  value: 'none',
                  label: 'No Fulfillment'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'msgvisitorstocanada?'
            }
          ],
          configuration_form: configurationForm('msgvisitorstocanada')
        },
        rimivisitorstocanada: {
          restrictVoid: true,
          defaultEmail: null,
          partial_skip_validation: false,
          searchQuotes: true,
          upload_path: [
            {
              canUpload: false,
              radioButtons: true,
              options: [
                {
                  value: 'email',
                  label: 'Separate Emails'
                },
                {
                  value: 'none',
                  label: 'No Fulfillment'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'rimivisitorstocanada?'
            }
          ],
          configuration_form: configurationForm('rimivisitorstocanada'),
        },
        rimicanuckvoyage: {
          restrictVoid: true,
          defaultEmail: null,
          partial_skip_validation: false,
          searchQuotes: true,
          upload_path: [
            {
              canUpload: false,
              radioButtons: true,
              options: [
                {
                  value: 'email',
                  label: 'Separate Emails'
                },
                {
                  value: 'none',
                  label: 'No Fulfillment'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'rimicanuckvoyage?'
            }
          ],
          configuration_form: configurationForm('rimicanuckvoyage'),
        },
        rimissis: {
          restrictVoid: true,
          defaultEmail: null,
          partial_skip_validation: true,
          searchQuotes: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'rimissis?'
            }
          ],
          configuration_form: configurationForm('rimissis'),
        },
        visitcanadavisitors: {
          restrictVoid: true,
          defaultEmail: null,
          partial_skip_validation: false,
          searchQuotes: true,
          upload_path: [
            {
              canUpload: false,
              radioButtons: true,
              options: [
                {
                  value: 'email',
                  label: 'Separate Emails'
                },
                {
                  value: 'none',
                  label: 'No Fulfillment'
                }
              ]
            }
          ],
          form_path: [
            {
              link: '2visitcanadavisitors?'
            }
          ],
          configuration_form: configurationForm('visitcanadavisitors'),
        },
        studentaccidentplan: {
          defaultEmail: null,
          partial_skip_validation: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'zip',
                  label: 'Zip'
                },
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'studentaccidentplan?'
            }
          ],
          configuration_form: configurationForm('studentaccidentplan'),
        },
        tpageneric: {
          defaultEmail: null,
          partial_skip_validation: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'tpageneric?'
            }
          ],
          configuration_form: configurationForm('tpageneric')
        },
        blanket: {
          defaultEmail: null,
          partial_skip_validation: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'blanket?'
            }
          ],
          configuration_form: configurationForm('blanket')
        },
        ubcimedblanket: {
          defaultEmail: null,
          partial_skip_validation: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'none',
                  label: 'No Fulfillment'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'ubcimedblanket?'
            }
          ],
          configuration_form: configurationForm('ubcimedblanket')
        },
        visitcanadais: {
          defaultEmail: null,
          partial_skip_validation: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              link: '2visitcanadais?'
            }
          ],
          configuration_form: configurationForm('visitcanadais')
        },
        insurecanadais: {
          defaultEmail: null,
          partial_skip_validation: true,
          upload_path: [
            {
              canUpload: true,
              options: [
                {
                  value: 'email',
                  label: 'Separate Emails'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'insurecanadais?'
            }
          ],
          configuration_form: configurationForm('insurecanadais')
        },
        insurecanadavisitor: {
          restrictVoid: true,
          defaultEmail: null,
          partial_skip_validation: false,
          searchQuotes: true,
          upload_path: [
            {
              canUpload: false,
              radioButtons: true,
              options: [
                {
                  value: 'email',
                  label: 'Separate Emails'
                },
                {
                  value: 'none',
                  label: 'No Fulfillment'
                }
              ]
            }
          ],
          form_path: [
            {
              link: 'insurecanadavisitor?'
            }
          ],
          configuration_form: configurationForm('insurecanadavisitor')
        },
        rimicanuckvoyagenonmed: {
          defaultEmail: null,
          partial_skip_validation: false,
          upload_path: [
            {
              canUpload: false
            }
          ],
          form_path: [
            {
              link: 'rimicanuckvoyagenonmed?'
            }
          ],
          configuration_form: configurationForm('rimicanuckvoyagenonmed'),
        },
      },
      insurers: {
        rimi: [
          {
            name: 'lloyds',
            label: 'Lloyd\'s',
          }
        ],
        msg: [
          {
            name: 'lloyds',
            label: 'Lloyd\'s',
          }
        ],
        ingle: [
          {
            name: 'lloyds',
            label: 'Lloyd\'s',
          },
          {
            name: 'berkley',
            label: 'Berkley',
          }
        ],
        visitcanada: [
          {
            name: 'lloyds',
            label: 'Lloyd\'s',
          }
        ],
        insurecanada: [
          {
            name: 'lloyds',
            label: 'Lloyd\'s',
          }
        ],
      },
      resource_centre: {
        pageInfo: {
          resource: {
            title: 'Resource Centre',
            info: 'Welcome to the resource centre! Each section below offers key information on travel insurance to help build your knowledge of the industry. Read on to find informative articles, travel resources, helpful guides written just for our partners, and more.'
           },
          blogs: {
            title: 'Blog',
            info: null,
            url_suffix : '/listblogposts',
            payload : null
           },
          sales: {
            title: 'Sales Tools',
            info: 'Below is a collection of documents and videos created to help you navigate the world of travel insurance with MSH International. Watch a training video and demonstration of our easy to use MSHagents.com web portal, and start using our online system 24/7! Use these documents to facilitate your sales process or distribute them to your clients along with their policies.',
            url_suffix : '/listblogposts',
            payload : {'tags': ['sales-tools']}
           },
          government: {
            title: 'Government Resources',
            info: 'National governments are often the best resource for detailed information about the situation on the ground. Are your clients travelling to an area experiencing violent political strife? Know where to go and what to avoid, and help them travel safe.'
           },
           training: {
             title: 'Training Material',
             info: 'Training videos, documents and other supportive material for Agents',
             url_suffix : '/listblogposts',
             payload : {'tags': ['training']}
           }
        },
        resources: {
          sales: {
            title: 'Sales Tool',
            type: 'sales',
            shortIntro: 'These documents can help you to facilitate your sales process.',
            logo: 'http://msh-assets.s3.ca-central-1.amazonaws.com/mshtravel/docs/ResourceImages/SalesTools.png',
            fetchFromWP : true
          },
          blogs: {
            title: 'Blog',
            type: 'blogs',
            shortIntro: 'Stay informed with the latest information from our resident travel insurance experts.',
            logo: 'http://msh-assets.s3.ca-central-1.amazonaws.com/mshtravel/docs/ResourceImages/Blog.png',
            fetchFromWP : true
          },
          government: {
            title: 'Government Resources',
            type: 'government',
            shortIntro: 'Access free resources from trusted government websites.',
            logo: 'http://msh-assets.s3.ca-central-1.amazonaws.com/mshtravel/docs/ResourceImages/GovernmentResources.png',
            fetchFromWP : false
          },
          currency: {
            title: 'Currency Exchange',
            type: 'currency',
            extLink: 'https://www.bankofcanada.ca/rates/exchange/?page_moved=1',
            shortIntro: 'Get important financial information for your international customers.',
            logo: 'http://msh-assets.s3.ca-central-1.amazonaws.com/mshtravel/docs/ResourceImages/CurrencyExchange.png',
            fetchFromWP : false
          },
          training: {
            title: 'Training Material',
            type: 'training',
            shortIntro: 'Training videos, documents and other supportive material for Agents',
            logo: 'http://msh-assets.s3.ca-central-1.amazonaws.com/mshtravel/docs/ResourceImages/TrainingMaterials.png',
            fetchFromWP : true
          },
        },
        government: [
          {
            title: 'Public Health Agency of Canada – Travel Health Notices',
            link: 'https://www.canada.ca/en/public-health/services/travel-health.html',
            type: 'governmentresources',
            shortIntro: 'This website provides updates about health crises worldwide, including travel advisory levels for affected destinations.',
            logo: 'http://msh-assets.s3.ca-central-1.amazonaws.com/mshtravel/docs/ResourceImages/CanadaPublicHealthTravelNotices.png'
          },
          {
            title: 'Travel Reports and Warnings',
            link: 'https://travel.gc.ca/travelling/advisories',
            type: 'governmentresources',
            shortIntro: 'This website offers information on safety and security, local laws and customs, entry requirements, health conditions, and important travel updates.',
            logo: 'http://msh-assets.s3.ca-central-1.amazonaws.com/mshtravel/docs/ResourceImages/TravelReportsAndWarnings.png'
          },
          {
            title: 'US Travel Warnings',
            link: 'https://travel.state.gov/content/travel/en/traveladvisories/traveladvisories.html',
            type: 'governmentresources',
            shortIntro: 'This website provides information about every country in the world. For each country, you will find information on visa requirements, crime and security, health conditions, drug penalties, and localized hot spots.',
            logo: 'http://msh-assets.s3.ca-central-1.amazonaws.com/mshtravel/docs/ResourceImages/USTravelWarnings.png'
          },
          {
            title: 'Directory of Canadian Government Offices Abroad',
            link: 'https://travel.gc.ca/assistance/embassies-consulates',
            type: 'governmentresources',
            shortIntro: 'This directory contains website and contact information for Canadian government offices abroad. These offices provide a variety of services to Canadians, including consular services.',
            logo: 'http://msh-assets.s3.ca-central-1.amazonaws.com/mshtravel/docs/ResourceImages/CanadianOfficesAbroad.png'
          },
          {
            title: 'US Department of State',
            link: 'https://www.state.gov',
            type: 'governmentresources',
            shortIntro: 'The United States federal executive department is responsible for the United States’ international relations, and is the equivalent of foreign ministries in other countries.',
            logo: 'http://msh-assets.s3.ca-central-1.amazonaws.com/mshtravel/docs/ResourceImages/USDepartmentOfState.png'
          },
          {
            title: 'Foreign and Commonwealth Office',
            link: 'https://www.gov.uk/government/organisations/foreign-commonwealth-office',
            type: 'governmentresources',
            shortIntro: 'This website includes the latest travel advice, news, foreign policy work, careers info, registration services, country profiles, and advice for businesses.',
            logo: 'http://msh-assets.s3.ca-central-1.amazonaws.com/mshtravel/docs/ResourceImages/ForeignAndCommonwealthOffice.png'
          }
        ]
      },
      dropbox_expiry_days: 30,
      validate_truenorth_fields: {
        first_name: 'First Name',
        last_name: 'Last Name',
        dob: 'Date of Birth',
        age: 'Age on effective date',
        sex: 'Gender',
        address_line_1: 'Address Line 1',
        address_line_2: 'Address Line 2',
        city: 'City',
        state: 'Province',
        country_code: 'Country',
        postal_code: 'Postal Code',
        phone: 'Phone Number',
        email: 'Email Address',
        cc_email: 'Additional Email Address',
        student_number: 'Student Number',
        legal_guardian: 'Legal Guardian',
        country_of_origin: 'Country of Origin',
        school: 'Name of School',
        other_plan: 'Other Insurance'
      }
    }
  }

}

export default BaseConfig;



// WEBPACK FOOTER //
// ./src/config/base.js